import { Star, ShoppingBag, Loader2 } from "lucide-react";
import { STATUS } from "../lib/api";
import { useSite } from "../context/SiteContext";

export const Logo = ({ light = false }) => {
  const { site } = useSite();
  const brand = site?.brand;
  if (brand?.logo_url) return <img src={brand.logo_url} alt={brand.name} className="h-10 w-auto max-w-[180px] object-contain" data-testid="bo-logo" />;
  const custom = brand && brand.name !== "BÔ Market";
  return (
  <div className="flex items-center gap-2" data-testid="bo-logo">
    <span className="relative grid h-10 w-10 place-items-center rounded-xl bg-bo-yellow shadow-sm">
      <ShoppingBag className="h-5 w-5 text-bo-green" strokeWidth={2.5} />
    </span>
    <span className="leading-none">
      <span className={`block text-[22px] font-extrabold tracking-tight ${light ? "text-white" : "text-bo-ink"}`}>
        {custom ? brand.name : <><span className={light ? "text-bo-yellow" : "text-bo-green"}>BÔ</span> Market</>}
      </span>
      <span className={`block text-[11px] font-medium ${light ? "text-white/70" : "text-gray-500"}`}>
        {brand ? brand.tagline : "Compra. Compara. Recebe."}
      </span>
    </span>
  </div>
  );
};

export const Stars = ({ value = 0, count }) => (
  <span className="inline-flex items-center gap-1 text-xs text-gray-500">
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} className={`h-3.5 w-3.5 ${i <= Math.round(value) ? "fill-bo-yellow text-bo-yellow" : "text-gray-300"}`} />
    ))}
    <span className="ml-0.5 font-medium text-gray-600">{Number(value || 0).toFixed(1)}</span>
    {count != null && <span>({count})</span>}
  </span>
);

export const DemoBadge = ({ className = "" }) => (
  <span className={`rounded-md bg-gray-900/80 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider text-white ${className}`}
    data-testid="demo-badge">DEMO</span>
);

export const SoonBadge = () => (
  <span className="w-fit whitespace-nowrap rounded-full bg-bo-yellow/90 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-bo-ink">
    Em preparação
  </span>
);

export const StatusBadge = ({ status }) => {
  const s = STATUS[status] || { label: status, cls: "bg-gray-100" };
  return <span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${s.cls}`} data-testid={`status-${status}`}>{s.label}</span>;
};

export const Spinner = () => (
  <div className="grid place-items-center py-16 text-bo-green" data-testid="loading-spinner">
    <Loader2 className="h-7 w-7 animate-spin" />
  </div>
);

export const Empty = ({ icon: Icon, title, text, action }) => (
  <div className="bo-card flex flex-col items-center gap-3 px-6 py-14 text-center" data-testid="empty-state">
    {Icon && <Icon className="h-10 w-10 text-bo-green/60" />}
    <p className="text-lg font-semibold">{title}</p>
    {text && <p className="max-w-md text-sm text-gray-500">{text}</p>}
    {action}
  </div>
);

export const PageTitle = ({ title, sub, right }) => (
  <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
    <div>
      <h1 className="text-2xl font-extrabold tracking-tight sm:text-3xl" data-testid="page-title">{title}</h1>
      {sub && <p className="mt-1 text-sm text-gray-500">{sub}</p>}
    </div>
    {right}
  </div>
);

export const Field = ({ label, children }) => (
  <label className="block text-sm">
    <span className="mb-1 block font-medium text-gray-700">{label}</span>
    {children}
  </label>
);

export const inputCls =
  "w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 text-sm outline-none transition-colors focus:border-bo-green focus:ring-2 focus:ring-bo-green/20";

export const btnPrimary =
  "inline-flex items-center justify-center gap-2 rounded-full bg-bo-green px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-bo-deep disabled:cursor-not-allowed disabled:opacity-50";

export const btnYellow =
  "inline-flex items-center justify-center gap-2 rounded-full bg-bo-yellow px-5 py-2.5 text-sm font-bold text-bo-ink transition-transform hover:-translate-y-0.5 disabled:opacity-50";

export const btnGhost =
  "inline-flex items-center justify-center gap-2 rounded-full border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:border-bo-green hover:text-bo-green disabled:opacity-50";
